/* @ngdoc object
 * @name guestlists
 * @description
 *
 */
angular
    .module('festzelt-os.exports', [
        'ui.router',
        'festzelt-os.components'
    ]);

require('./exports-routes');

// Controllers
require('./controllers/billing-controller');
require('./controllers/rsvps-controller');



// WEBPACK FOOTER //
// ./src/app/pages/exports/exports-module.js